import { render, staticRenderFns } from "./coachBaseInfoAudit.vue?vue&type=template&id=63a913ae&scoped=true"
import script from "./coachBaseInfoAudit.vue?vue&type=script&lang=ts"
export * from "./coachBaseInfoAudit.vue?vue&type=script&lang=ts"
import style0 from "./coachBaseInfoAudit.vue?vue&type=style&index=0&id=63a913ae&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a913ae",
  null
  
)

export default component.exports